// ============================================================
//  Sticky Kompaktleiste des Plans: Positionen, Zielzustand-Δ, € / Jahr, Bedarf nach Plan
//  gegen den Vertrag. Rechnet über planResult (R4) — dieselbe Zahl wie im Reiter „Plan".
//  Schnittstelle: <PlanBar />
// ============================================================
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { ClipboardList } from "lucide-react";
import { useApp } from "../../store/AppStore";
import { usePlanItems } from "../../store/plan";
import { planResult } from "../../domain/plan";
import { formatEuro, formatFue, formatNum } from "../../domain/rules";
import { InfoTip } from "./Erklaerung";

export function PlanBar() {
  const { ds, ratio, price, contracted } = useApp();
  const items = usePlanItems();
  const r = useMemo(() => planResult(ds, items, ratio, price), [ds, items, ratio, price, contracted]);
  const puffer = r.restLuecke <= 0;
  return (
    <div className="sticky top-[72px] z-10 mb-5">
      <div className="bg-card shadow-card flex flex-wrap items-center justify-between gap-3 rounded-xl border-strong px-4 py-3" style={{ borderWidth: 1 }}>
        <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1">
          <span className="text-strong inline-flex items-center gap-2 text-base font-semibold"><ClipboardList size={18} className="text-dim" /> {formatNum(r.items)} {r.items === 1 ? "Position" : "Positionen"} im Plan</span>
          <span className="tnum font-semibold" style={{ color: "var(--color-amp-green)" }}>−{formatFue(r.reduction)} <span className="text-faint text-xs font-normal">Zielzustand</span></span>
          <span className="tnum font-semibold" style={{ color: "var(--color-amp-green)" }}>−{formatEuro(r.euroSaved)} <span className="text-faint text-xs font-normal">/ Jahr</span></span>
          <span className="tnum text-dim text-sm">Bedarf nach Plan <span className="text-strong font-semibold">{formatFue(r.afterPlan)}</span> · <span className="font-semibold" style={{ color: puffer ? "var(--color-amp-green)" : "var(--color-amp-red)" }}>{puffer ? "Puffer" : "Lücke"} {formatFue(Math.abs(r.restLuecke))}</span>
            <InfoTip>Bedarf nach Plan = Bedarf heute ({formatFue(r.ist)}) − Zielzustand-Reduktion. Vertrag {formatFue(r.contracted)}. Jede Person zählt einmal, auch wenn mehrere Positionen sie treffen (R4).</InfoTip>
          </span>
        </div>
        <Link to="/plan" className="rounded-lg px-3 py-1.5 text-sm font-medium" style={{ backgroundColor: "var(--color-brand-600)", color: "#fff" }}>Plan öffnen</Link>
      </div>
    </div>
  );
}
